import React, { Suspense } from 'react'
import LayoutSkeleton from 'common/Skeletons/LayoutSkeleton'
import FaberGlobalUserSearch from 'pages/Customers/vendor/Faber/otpackComponents/FaberGlobalUserSearch'

export default function FaberGlobalDashboard() {
  return (
    <>
      <Suspense fallback={<LayoutSkeleton />}>
        <FaberGlobalUserSearch />
      </Suspense>
    </>
  )
}
